// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"ce1fb4d1","219":"ce1fb4d1","240":"ce1fb4d1","267":"ce1fb4d1","712":"ce1fb4d1","816":"ce1fb4d1","891":"ce1fb4d1"}[chunkId] + ".chunk.css";
};